var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "head-container" },
      [
        _vm.crud.props.searchToggle
          ? _c(
              "div",
              [
                _c("label", { staticClass: "el-form-item-label" }, [
                  _vm._v("编号"),
                ]),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "filter-item",
                  staticStyle: { width: "185px" },
                  attrs: { clearable: "", placeholder: "编号" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.crud.toQuery($event)
                    },
                  },
                  model: {
                    value: _vm.query.statId,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "statId", $$v)
                    },
                    expression: "query.statId",
                  },
                }),
                _vm._v(" "),
                _c("label", { staticClass: "el-form-item-label" }, [
                  _vm._v("创建人"),
                ]),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "filter-item",
                  staticStyle: { width: "185px" },
                  attrs: { clearable: "", placeholder: "创建人" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.crud.toQuery($event)
                    },
                  },
                  model: {
                    value: _vm.query.userId,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "userId", $$v)
                    },
                    expression: "query.userId",
                  },
                }),
                _vm._v(" "),
                _c("label", { staticClass: "el-form-item-label" }, [
                  _vm._v("部门"),
                ]),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "filter-item",
                  staticStyle: { width: "185px" },
                  attrs: { clearable: "", placeholder: "部门" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.crud.toQuery($event)
                    },
                  },
                  model: {
                    value: _vm.query.deptId,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "deptId", $$v)
                    },
                    expression: "query.deptId",
                  },
                }),
                _vm._v(" "),
                _c("rrOperation", { attrs: { crud: _vm.crud } }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("crudOperation", { attrs: { permission: _vm.permission } }),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              "close-on-click-modal": false,
              "before-close": _vm.crud.cancelCU,
              visible: _vm.crud.status.cu > 0,
              title: _vm.crud.status.title,
              width: "750px",
            },
            on: {
              "update:visible": function ($event) {
                return _vm.$set(_vm.crud.status, "cu > 0", $event)
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  size: "small",
                  "label-width": "80px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "报表名称" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "370px" },
                      model: {
                        value: _vm.form.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "title", $$v)
                        },
                        expression: "form.title",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "排序" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "370px" },
                      model: {
                        value: _vm.form.sort,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "sort", $$v)
                        },
                        expression: "form.sort",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "查询分类" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        staticStyle: { width: "100%" },
                        model: {
                          value: _vm.form.queryItemType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "queryItemType", $$v)
                          },
                          expression: "form.queryItemType",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: "depts" } }, [
                          _vm._v("按部门"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-radio-button",
                          { attrs: { label: "cust_msg_from" } },
                          [_vm._v("按o2o渠道")]
                        ),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: "zx_from" } }, [
                          _vm._v("按导购渠道"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-radio-button",
                          { attrs: { label: "business_from" } },
                          [_vm._v("按市场渠道")]
                        ),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: "users" } }, [
                          _vm._v("按人员"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "demo-dynamic" },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "dynamicValidateForm",
                            attrs: { model: _vm.dynamicValidateForm },
                          },
                          [
                            _vm._l(
                              _vm.dynamicValidateForm.domains,
                              function (domain, index) {
                                return _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "domains." + index + ".value",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: domain.prop,
                                          callback: function ($$v) {
                                            _vm.$set(domain, "prop", $$v)
                                          },
                                          expression: "domain.prop",
                                        },
                                      },
                                      _vm._l(_vm.item_cities, function (item) {
                                        return _c("el-option", {
                                          key: item.prop,
                                          attrs: {
                                            label: item.label,
                                            value:
                                              item.query != undefined
                                                ? item.query
                                                : item.prop2 == undefined
                                                ? item.prop
                                                : item.prop2,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: domain.func,
                                          callback: function ($$v) {
                                            _vm.$set(domain, "func", $$v)
                                          },
                                          expression: "domain.func",
                                        },
                                      },
                                      _vm._l(_vm.items, function (item) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: item.tag,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { float: "left" },
                                              },
                                              [_vm._v(_vm._s(item.tag))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#8492a6",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.label))]
                                            ),
                                          ]
                                        )
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    domain.prop == "followStatus1" ||
                                    domain.prop == "updateStatus1"
                                      ? _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              multiple: "",
                                              filterable: "",
                                              placeholder: "请选择",
                                            },
                                            on: { change: _vm.onDataChange },
                                            model: {
                                              value: domain.value,
                                              callback: function ($$v) {
                                                _vm.$set(domain, "value", $$v)
                                              },
                                              expression: "domain.value",
                                            },
                                          },
                                          _vm._l(
                                            _vm.all_statuss,
                                            function (item) {
                                              return _c(
                                                "el-option",
                                                {
                                                  key: item.name,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.name,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        float: "left",
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        float: "right",
                                                        color: "#8492a6",
                                                        "font-size": "13px",
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.label))]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _c("el-input", {
                                          staticStyle: { width: "100px" },
                                          model: {
                                            value: domain.value,
                                            callback: function ($$v) {
                                              _vm.$set(domain, "value", $$v)
                                            },
                                            expression: "domain.value",
                                          },
                                        }),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.removeDomain(domain)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            _vm._v(" "),
                            _vm.form.itemType == "公式"
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "数据源选项" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "370px" },
                                        attrs: {
                                          multiple: "",
                                          filterable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.form.itemProp,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "itemProp", $$v)
                                          },
                                          expression: "form.itemProp",
                                        },
                                      },
                                      _vm._l(
                                        _vm.statItemSources,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.id,
                                            attrs: {
                                              label: item.itemLabel,
                                              value: item.itemLabel,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.itemType == "公式"
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "计算方式" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "370px" },
                                      attrs: { rows: 3, type: "textarea" },
                                      model: {
                                        value: _vm.form.itemFunc,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "itemFunc", $$v)
                                        },
                                        expression: "form.itemFunc",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-bottom": "5px" },
                                      },
                                      _vm._l(
                                        _vm.form.itemProp,
                                        function (item) {
                                          return _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                "margin-right": "5px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onClick(item)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(item))]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-bottom": "5px" },
                                      },
                                      _vm._l(_vm.formulaFuncs, function (item) {
                                        return _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onClick(item)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item))]
                                        )
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-bottom": "5px" },
                                      },
                                      _vm._l(_vm.formulaNums, function (item) {
                                        return _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onClick(item)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item))]
                                        )
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-button", { on: { click: _vm.addDomain } }, [
                          _vm._v("新增条件+"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "显示选项" } },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 23 } },
                          [
                            _c("el-transfer", {
                              attrs: {
                                titles: ["可选选项", "已选选项"],
                                props: { key: "prop", label: "label" },
                                data: _vm.cities,
                                "target-order": "push",
                              },
                              on: {
                                change: _vm.handleTabelItemChange,
                                "right-check-change": _vm.rightCheck,
                              },
                              model: {
                                value: _vm.rightItem,
                                callback: function ($$v) {
                                  _vm.rightItem = $$v
                                },
                                expression: "rightItem",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: { "margin-top": "95px" },
                            attrs: { span: 1 },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-bottom": "10px",
                                  "margin-left": "-20px",
                                },
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    icon: "el-icon-arrow-up",
                                    circle: "",
                                  },
                                  on: { click: _vm.upData },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-bottom": "10px",
                                  "margin-left": "-20px",
                                },
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    icon: "el-icon-arrow-down",
                                    circle: "",
                                  },
                                  on: { click: _vm.downData },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  { attrs: { type: "text" }, on: { click: _vm.crud.cancelCU } },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      loading: _vm.crud.status.cu === 2,
                      type: "primary",
                    },
                    on: { click: _vm.crud.submitCU },
                  },
                  [_vm._v("确认")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.crud.loading,
                expression: "crud.loading",
              },
            ],
            ref: "table",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.crud.data, size: "small" },
            on: { "selection-change": _vm.crud.selectionChangeHandler },
          },
          [
            _c("el-table-column", {
              attrs: { type: "selection", width: "55" },
            }),
            _vm._v(" "),
            _c("el-table-column", { attrs: { prop: "statId", label: "编号" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "title", label: "统计表名/目录名" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "queryItemType", label: "查询类型" },
            }),
            _vm._v(" "),
            _c("el-table-column", { attrs: { prop: "sort", label: "排序" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "userId", label: "创建人" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "createTime", label: "创建时间" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "updateTime", label: "更新时间" },
            }),
            _vm._v(" "),
            _vm.checkPer(["admin", "stat:edit", "stat:del"])
              ? _c("el-table-column", {
                  attrs: { label: "操作", width: "150px", align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("udOperation", {
                              attrs: {
                                data: scope.row,
                                permission: _vm.permission,
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    398919237
                  ),
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("pagination"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }